module.exports = __webpack_public_path__ + "media/images/top/img_interview_shota-482e0e31b59264e360aa1f9365b4f1f6.jpg";